<style>
  .modal-dialog {
    position: fixed !important;
  }
</style>
<div class="row mb-2">
  <div class="d-flex justify-content-between">
    <div class="col-sm-12">
      <button
        class="btn btn-warning border-right-warning mb-2 mb-md-0 pulsingButton"
        (click)="OpenModalXl(contentTutoriais)"
      >
        <i class="fa fa-play-circle-o"></i> Ver Vídeo Tutorial
      </button>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between">
          <h3 class="card-title">
            {{
              !canEdit && training
                ? nomeTreino
                : canEdit && training
                ? nomeTreino
                : "Novo Treino"
            }}
          </h3>
          <p *ngIf="training && training.type">{{ getTipoTreino() }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <p>
          {{
            !canEdit && training
              ? nomeTreino
              : canEdit && training
              ? "Edite o treino e seus exercícios"
              : "Crie um treino e adicione exercícios parâmetrizados"
          }}
        </p>
      </div>
    </div>
  </div>
  <div class="card-content">
    <div class="card-body">
      <aw-wizard
        #wizard
        [defaultStepIndex]="currentIndex"
        [navBarLayout]="'large-empty-symbols'"
      >
        <aw-wizard-step
          *ngIf="!(!canEdit && training)"
          [stepTitle]="'Treino'"
          [navigationSymbol]="{ symbol: '&#xf21e;', fontFamily: 'FontAwesome' }"
        >
          <form #firstForm="ngForm" class="editForm" novalidate>
            <br />
            <div
              class="form-row"
              *ngIf="
                !training &&
                trainingModels.length > 0 &&
                !verificaTreinoDeAvaliacaoPreenchido() &&
                !isModel
              "
            >
              <div class="col-12">
                <div class="form-group mb-2">
                  <label for="nome"
                    >Você pode selecionar um treino modelo</label
                  >
                  <ng-select
                    [notFoundText]="'Nenhum treino encontrado'"
                    [items]="trainingModels"
                    bindLabel="name"
                    name="model"
                    placeholder="Selecionar Modelo"
                    id="basic-form-model"
                    [(ngModel)]="trainingModelselecionada"
                    (ngModelChange)="onselectModel()"
                    required="true"
                  ></ng-select>
                </div>
              </div>
            </div>
            <div class="form-row" id="step6">
              <div class="col-12">
                <div class="form-group mb-2">
                  <label for="tipotreino">{{
                    ultimoTipoSelecionado
                      ? ultimoTipoSelecionado
                      : "Tipo de Treino"
                  }}</label>
                  <ng-select
                    [notFoundText]="'Nenhum tipo encontrado'"
                    [items]="tipos"
                    [disabled]="verificaEditarTreino()"
                    bindLabel="name"
                    name="model"
                    placeholder="Selecionar Tipo"
                    id="tipotreino"
                    [(ngModel)]="tipoSelecionado"
                    (ngModelChange)="toggleTipoTreino()"
                  ></ng-select>
                </div>
              </div>
            </div>
            <div
              class="form-row"
              *ngIf="
                tipoSelecionado &&
                (tipoSelecionado.id == 2 || tipoSelecionado.id == 3)
              "
            >
              <div [ngClass]="group ? 'col-md-6 col-12' : 'col-12'">
                <div class="form-group mb-2">
                  <label for="volt"
                    >Voltas <span style="color: red">*</span></label
                  >
                  <div class="input-group">
                    <input
                      type="text"
                      autocomplete="off"
                      id="volt"
                      mask="0*"
                      class="form-control"
                      name="volt"
                      [(ngModel)]="newTraining.laps"
                      #volt="ngModel"
                      gt="0"
                      required
                    />
                  </div>
                  <small
                    class="form-text text-muted danger"
                    *ngIf="volt.errors?.required || volt.errors?.gt"
                    >Você deve informar a quantidade de voltas</small
                  >
                </div>
              </div>
              <div class="col-md-6 col-12" *ngIf="group">
                <div
                  class="form-group mb-2"
                  placement="top"
                  ngbTooltip="Válido para quando você ocultar as variáveis do último exercício."
                >
                  <label for="volt">Intervalo entre voltas</label>
                  <div class="input-group">
                    <ngb-timepicker
                      name="breakDuration"
                      [spinners]="false"
                      [seconds]="true"
                      [(ngModel)]="newTraining.breakTime"
                      required
                      #duration1="ngModel"
                    ></ngb-timepicker>
                    <small
                      class="form-text text-muted danger"
                      *ngIf="duration1.errors?.required"
                      >Você deve informar a duração do intervalo</small
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row"
              *ngIf="tipoSelecionado && tipoSelecionado.id != 4 && !isModel"
            >
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label for="agend">Agendamento</label>
                  <div class="input-group mb-1">
                    <input
                      type="text"
                      autocomplete="off"
                      id="agend"
                      placeholder="00/00/0000"
                      class="form-control"
                      name="agend"
                      [(ngModel)]="agendamento"
                      ngbDatepicker
                      #agend="ngbDatepicker"
                      [container]="'body'"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-secondary input-group-text"
                        (click)="agend.toggle()"
                      >
                        <i class="fa fa-calendar"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label for="agend">Vencimento</label>
                  <div class="input-group mb-1">
                    <input
                      type="text"
                      id="vencimento"
                      placeholder="00/00/0000"
                      class="form-control"
                      name="vencimento"
                      [(ngModel)]="vencimento"
                      ngbDatepicker
                      #venc="ngbDatepicker"
                      [container]="'body'"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-secondary input-group-text"
                        (click)="venc.toggle()"
                      >
                        <i class="fa fa-calendar"></i>
                      </button>
                    </div>
                  </div>
                  <small
                    class="form-text text-muted danger mt-0"
                    *ngIf="errorDate"
                    >A Data de vencimento não pode ser igual a de
                    agendamento</small
                  >
                </div>
              </div>
            </div>
            <div class="form-row" id="step7">
              <div class="col-12">
                <div class="form-group mb-2">
                  <label for="inputAvaliacao"
                    >Nome <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    autocomplete="off"
                    id="inputAvaliacao"
                    class="form-control"
                    name="inputAvaliacao"
                    [disabled]="verificaTreinoDeAvaliacaoPreenchido()"
                    [(ngModel)]="newTraining.name"
                    #inputAvaliacao="ngModel"
                    required
                  />
                  <small
                    class="form-text text-muted danger"
                    *ngIf="inputAvaliacao.errors?.required"
                    >Informe um nome para o treino</small
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12">
                <div class="form-group mb-2">
                  <label for="obst">Observações <span class="badge rounded-pill badge-primary">Não Utilize Emojis ex: 😀🚨</span></label>
                  <textarea
                    id="obst"
                    rows="3"
                    class="form-control"
                    name="obst"
                    maxlength="500"
                    [disabled]="verificaTreinoDeAvaliacaoPreenchido()"
                    [(ngModel)]="newTraining.note"
                    #inputObs="ngModel"
                    placeholder="Você pode escrever observações sobre este treino"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 text-center">
                <div class="d-md-none">
                  <button
                    type="button"
                    class="btn btn-outline-danger btn-icon float-left"
                    (click)="cancelaTreino()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                  <button
                    type="button"
                    (click)="verificaTutorial()"
                    id="step8m"
                    class="btn btn-outline-success btn-icon float-right"
                    [disabled]="!verificaPreenchimentoTreino()"
                    awNextStep
                  >
                    <i class="fa fa-arrow-right"></i>
                  </button>
                </div>
                <div class="d-none d-md-block">
                  <button
                    type="button"
                    class="btn btn-lg btn-danger mr-2"
                    (click)="cancelaTreino()"
                  >
                    {{ canEdit ? "Cancelar" : "Cancelar" }}
                  </button>
                  <button
                    type="button"
                    (click)="verificaTutorial()"
                    id="step8"
                    class="btn btn btn-lg btn-success"
                    [disabled]="!verificaPreenchimentoTreino()"
                    awNextStep
                  >
                    {{ canEdit ? "Próximo Passo" : "Avançar" }}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </aw-wizard-step>
        <aw-wizard-step
          [stepTitle]="'Exercícios'"
          [navigationSymbol]="{ symbol: '&#xf0cb;', fontFamily: 'FontAwesome' }"
        >
          <div class="form-row mt-4">
            <div class="col-md-12 col-12 mb-3 p-0">
              <div class="float-right d-none d-md-block" role="group">
                <button
                  type="button"
                  class="btn btn-lg btn-warning mb-md-0"
                  *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                  [disabled]="listaExercicios.length < 2"
                  (click)="openAssociar(modalConjugados)"
                >
                  <fa-icon [icon]="faLayerGroup"></fa-icon> Gerenciar Conjuntos
                </button>
              </div>
              <div class="float-right d-none d-md-block mr-2" role="group">
                <button
                  type="button"
                  class="btn btn-lg btn-warning mb-md-0"
                  id="step9"
                  (click)="openExercise(modalExercicio)"
                >
                  <i class="fa fa-plus"></i> Exercício
                </button>
              </div>
              <div
                class="float-right btn-group btn-group-lg d-md-none"
                role="group"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-warning mb-md-0"
                  *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                  [disabled]="listaExercicios.length < 2"
                  (click)="openAssociar(modalConjugados)"
                >
                  <fa-icon [icon]="faLayerGroup"></fa-icon>
                </button>
              </div>
              <div
                class="float-right btn-group btn-group-lg d-md-none mr-2"
                role="group"
              >
                <button
                  type="button"
                  class="btn btn-lg btn-warning mb-md-0"
                  id="step9m"
                  (click)="openExercise(modalExercicio)"
                >
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>
          </div>
          <form>
            <div class="form-row" *ngIf="listaExerciciosPrincipais.length > 0">
              <ul
                class="list-group mb-2 draglist"
                cdkDropList
                style="width: 100%"
                (cdkDropListDropped)="drop($event)"
              >
                <li
                  *ngFor="let exercicio of listaExerciciosPrincipais"
                  cdkDrag
                  class="list-group-item"
                  [ngStyle]="{
                    'border-top-left-radius':
                      listaExercicios.indexOf(exercicio) == 0 ? '50px' : '0',
                    'border-top-right-radius':
                      listaExercicios.indexOf(exercicio) == 0 ? '50px' : '0',
                    'border-bottom-left-radius':
                      listaExercicios.indexOf(exercicio) + 1 ==
                      listaExercicios.length
                        ? '50px'
                        : '0',
                    'border-bottom-right-radius':
                      listaExercicios.indexOf(exercicio) + 1 ==
                      listaExercicios.length
                        ? '50px'
                        : '0'
                  }"
                >
                  <div class="media">
                    <span class="dot align-middle mr-2">{{
                      listaExerciciosPrincipais.indexOf(exercicio) + 1
                    }}</span>
                    <div class="media-body">
                      <h5 class="mt-0">
                        {{
                          getNameExercise(exercicio)
                            ? getNameExercise(exercicio)
                            : exercicio.name
                        }}
                      </h5>
                      <span *ngIf="!getNameExercise(exercicio)">{{
                        getLabelCategory(exercicio.category)
                      }}</span>
                      <span *ngIf="getNameExercise(exercicio)">
                        <div *ngFor="let conj of getResumoConjunto(exercicio)">
                          <p>
                            {{
                              (
                                getResumoConjunto(exercicio).indexOf(conj) + 1
                              ).toString() +
                                " - " +
                                conj.name
                            }}
                          </p>
                        </div>
                      </span>
                    </div>
                    <div class="d-md-none" *ngIf="getNameExercise(exercicio)">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-warning mb-2 mb-md-0"
                        placement="left"
                        ngbTooltip="Clique para visualizar os exercícios deste conjunto."
                        (click)="
                          administrarConjunto(exercicio, modalEditConjugado)
                        "
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                    </div>
                    <div
                      class="d-none d-md-block"
                      *ngIf="getNameExercise(exercicio)"
                    >
                      <button
                        type="button"
                        class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                        placement="left"
                        ngbTooltip="Clique para visualizar os exercícios deste conjunto."
                        (click)="
                          administrarConjunto(exercicio, modalEditConjugado)
                        "
                      >
                        {{ "Visualizar " + getNameExercise(exercicio) }}
                      </button>
                    </div>
                    <div
                      class="d-none d-md-block"
                      *ngIf="!getNameExercise(exercicio)"
                    >
                      <div
                        class="btn-group btn-group-lg float-right"
                        role="group"
                      >
                        <button
                          type="button"
                          class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                          placement="left"
                          *ngIf="tipoSelecionado && tipoSelecionado.id != 4"
                          ngbTooltip="Duplicar exercício."
                          (click)="duplicarExercicio(exercicio)"
                        >
                          <i class="fa fa-copy"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                          placement="left"
                          role="button"
                          tabindex="0"
                          [ngbTooltip]="
                            tipoSelecionado &&
                            tipoSelecionado.id == 4 &&
                            training &&
                            training.TrainingExecution &&
                            training.TrainingExecution.length > 0
                              ? 'Visualizar exercício'
                              : 'Editar exercício.'
                          "
                          (click)="
                            editarExercicio(exercicio, modalExercicio, null)
                          "
                        >
                          <i class="fa fa-edit"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                          [disabled]="listaExercicios.length <= 1"
                          placement="left"
                          ngbTooltip="Remover exercício."
                          (click)="removerExercicio(exercicio)"
                          *ngIf="verificaExercicio(exercicio)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                    <div
                      class="d-md-none"
                      role="group"
                      *ngIf="!getNameExercise(exercicio)"
                    >
                      <div class="dropdown btn-group-sm mr-1 mb-1" ngbDropdown>
                        <button
                          type="button"
                          class="btn btn-outline-warning btn-sm dropdown-toggle"
                          ngbDropdownToggle
                        >
                          <i class="ft-more-vertical"></i>
                        </button>
                        <div ngbDropdownMenu class="dropdown-menu" role="menu">
                          <a
                            class="dropdown-item"
                            (click)="duplicarExercicio(exercicio)"
                            *ngIf="tipoSelecionado && tipoSelecionado.id != 4"
                            >Duplicar exercício</a
                          >
                          <a
                            class="dropdown-item"
                            (click)="
                              editarExercicio(exercicio, modalExercicio, null)
                            "
                            >{{
                              tipoSelecionado &&
                              tipoSelecionado.id == 4 &&
                              training &&
                              training.TrainingExecution &&
                              training.TrainingExecution.length > 0
                                ? "Visualizar exercício"
                                : "Editar exercício."
                            }}</a
                          >
                          <a
                            class="dropdown-item"
                            (click)="removerExercicio(exercicio)"
                            *ngIf="verificaExercicio(exercicio)"
                            >Remover exercício</a
                          >
                        </div>
                      </div>
                    </div>
                    <div class="mb-2 mt-2 ml-3">
                      <i
                        class="fa fa-reorder mr-2 text-muted"
                        cdkDragHandle
                        style="font-size: 25px; cursor: pointer"
                        placement="left"
                        ngbTooltip="Arraste para reordenar este exercício."
                      ></i>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="form-row" *ngIf="listaExercicios.length == 0">
              <ul class="list-group mb-2" style="width: 100%; overflow-y: auto">
                <li class="list-group-item">
                  <div class="media">
                    <div class="media-body">
                      <h5 class="mt-0">Nenhum exercício cadastrado.</h5>
                      <span>Adicione um novo exercício!</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div class="form-row mt-4" *ngIf="!idTreino">
              <div class="col-12 text-center">
                <p>
                  Você precisa <b>publicar</b> este treino para que ele seja
                  salvo
                </p>
              </div>
            </div>
            <div class="form-row">
              <div class="col-12 text-center">
                <button
                  type="button"
                  class="btn btn-lg btn-secondary mr-2"
                  awPreviousStep
                >
                  Voltar
                </button>

                <button
                  type="button"
                  id="step10"
                  class="btn btn-lg btn-success"
                  [disabled]="
                    listaExercicios.length == 0 ||
                    !verificaPreenchimentoTreino() ||
                    verificaTreinoDeAvaliacaoPreenchido()
                  "
                  (click)="cadastrarTreino(true)"
                >
                  <i class="fa fa-save mr-2"></i
                  >{{ idTreino ? "Salvar Treino" : "Publicar" }}
                </button>
              </div>
            </div>
          </form>
        </aw-wizard-step>
      </aw-wizard>
    </div>
  </div>
</div>

<ng-template #modalExercicio let-modal style="position: fixed !important">
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">
        {{
          isEditingExercise
            ? "Editar exercício do treino"
            : "Adicionar exercício ao treino"
        }}
        {{ nomeTreino }}
      </h4>
    </div>
    <div class="card-content">
      <div class="card-body">
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <aw-wizard-step
            [stepTitle]="'Exercício'"
            [navigationSymbol]="{
              symbol: '&#xf0cb;',
              fontFamily: 'FontAwesome'
            }"
          >
            <form #firstForm="ngForm" class="editForm" novalidate>
              <br />
              <div class="form-row">
                <div class="col-md-12 col-12">
                  <div class="float-right d-none d-md-block" role="group">
                    <button
                      type="button"
                      class="btn btn-lg btn-warning mb-md-0"
                      (click)="addExercise()"
                    >
                      <i class="fa fa-plus"></i> Criar Exercício
                    </button>
                  </div>
                  <div
                    class="btn-group btn-group-lg d-md-none float-right"
                    role="group"
                  >
                    <button
                      type="button"
                      class="btn btn-lg btn-warning mb-md-0"
                      (click)="addExercise()"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-row mt-3">
                <div class="form-group col-md-6 col-12 mb-2">
                  <label for="catselect">Selecione uma categoria</label>
                  <ng-select
                    [items]="categoriesAndExercicies"
                    [disabled]="verificaTreinoDeAvaliacaoPreenchido()"
                    [dropdownPosition]="'top'"
                    [notFoundText]="'Nenhuma categoria encontrada'"
                    bindLabel="name"
                    name="catselect"
                    placeholder="Selecionar Categoria"
                    id="catselect"
                    [(ngModel)]="categoriaSelecionada"
                    (ngModelChange)="onselectCategory()"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ item.name }}</span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <span
                        >{{ item.name
                        }}<small class="text-muted float-right">{{
                          item.user ? "personal" : "plataforma"
                        }}</small></span
                      >
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-group col-md-6 col-12 mb-2">
                  <label for="exercselect">Selecione um exercício</label>
                  <ng-select
                    [items]="exercicies"
                    [disabled]="
                      exercicies.length == 0 ||
                      verificaTreinoDeAvaliacaoPreenchido()
                    "
                    [notFoundText]="'Nenhum exercício encontrado'"
                    [dropdownPosition]="'top'"
                    bindLabel="Exercise.name"
                    name="blable"
                    placeholder="Selecionar Exercício"
                    id="blable"
                    [(ngModel)]="exercicioSelecionado"
                    (ngModelChange)="onselectExercicio()"
                    required
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ item.Exercise.name }}</span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <span
                        >{{ item.Exercise.name
                        }}<small class="text-muted float-right">{{
                          item.Exercise.user ? "personal" : "plataforma"
                        }}</small></span
                      >
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="form-group mb-2" *ngIf="exercicioSelecionado">
                <label for="exercselect">Mídia</label>
                <div class="col">
                  <ul class="list-unstyled mb-0">
                    <div class="mb-2 d-md-inline-block mr-lg-4">
                      <li
                        class="d-inline-block mr-2"
                        style="vertical-align: middle"
                        *ngIf="
                          exercicioSelecionado.Exercise &&
                          exercicioSelecionado.Exercise.url_video
                        "
                      >
                        <div class="radio radio-sm">
                          <input
                            type="radio"
                            name="size-radio-1"
                            [value]="true"
                            id="size-sm"
                            (click)="switchMidia(true)"
                            [(ngModel)]="isVideo"
                          />
                          <label for="size-sm"
                            ><a class="text-primary">Escolher Vídeo</a></label
                          >
                        </div>
                      </li>
                      <button
                        class="btn btn-sm btn-warning"
                        (click)="viewMidia(true, contentVideo, contentGif)"
                      >
                        <i class="fa fa-eye"></i> Ver Vídeo
                      </button>
                    </div>
                    <div class="mb-2 d-md-inline-block">
                      <li
                        class="d-inline-block mr-2"
                        style="vertical-align: middle"
                        *ngIf="
                          exercicioSelecionado.Exercise &&
                          exercicioSelecionado.Exercise.url_gif
                        "
                      >
                        <div class="radio radio-sm">
                          <input
                            type="radio"
                            name="size-radio-1"
                            [value]="false"
                            id="size-default"
                            (click)="switchMidia(false)"
                            [(ngModel)]="isVideo"
                          />
                          <label for="size-default"
                            ><a class="text-primary">Escolher GIF</a></label
                          >
                        </div>
                      </li>
                      <button
                        class="btn btn-sm btn-warning"
                        (click)="viewMidia(false, contentVideo, contentGif)"
                      >
                        <i class="fa fa-eye"></i> Ver GIF
                      </button>
                    </div>
                  </ul>
                </div>
              </div>
              <div class="form-row mt-4">
                <div class="col-12 text-center">
                  <div class="d-md-none">
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-icon float-left"
                      (click)="modal.close('Close click')"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-success btn-icon float-right"
                      id="step12m"
                      [disabled]="!verificaPrePreenchimentoExercicio()"
                      awNextStep
                    >
                      <i class="fa fa-arrow-right"></i>
                    </button>
                  </div>
                  <div class="d-none d-md-block">
                    <button
                      type="button"
                      class="btn btn-lg btn-danger mr-2"
                      [ngClass]="canEdit ? 'btn-danger' : 'btn-secondary'"
                      (click)="modal.close('Close click')"
                    >
                      {{ canEdit ? "Cancelar" : "Cancelar" }}
                    </button>
                    <button
                      type="button"
                      class="btn btn btn-lg btn-success"
                      id="step12"
                      [disabled]="!verificaPrePreenchimentoExercicio()"
                      awNextStep
                    >
                      {{ canEdit ? "Próximo Passo" : "Avançar" }}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step
            [stepTitle]="'Parâmetros'"
            [navigationSymbol]="{
              symbol: '&#xf085;',
              fontFamily: 'FontAwesome'
            }"
          >
            <form
              #workForm="ngForm"
              class="editForm mb-2"
              style="
                padding-left: 7px;
                padding-right: 7px;
                padding-top: 5px;
                padding-bottom: 5px;
                border-radius: 50px;
              "
              novalidate
            >
              <ng-template [ngIf]="group">
                <div class="form-row mt-3">
                  <div class="col-md-6 col-12">
                    <div class="form-group mr-2 float-right">
                      <label for="ttt" class="mr-2">Ocultar Variáveis</label>
                      <ui-switch
                        class="switchery switchery-warning"
                        id="ttt"
                        [checked]="switchHideVariables"
                        (change)="changeSwitchVariables($event)"
                      ></ui-switch>
                    </div>
                  </div>
                </div>
              </ng-template>
              <br />
              <div
                class="form-row"
                *ngIf="
                  exercicioSelecionado &&
                  tipoSelecionado &&
                  (tipoSelecionado.id == 2 || tipoSelecionado.id == 3)
                "
              >
                <div
                  class="col-md-3 col-12"
                  placement="top"
                  ngbTooltip="Você pode marcar este exercício como aquecimento. Assim ele será executado antes dos exercícios principais."
                >
                  <div class="form-group mb-2">
                    <label for="exercselect">Aquecimento</label>
                    <div class="input-group">
                      <ui-switch
                        class="switchery switchery-warning"
                        id="aqc"
                        [checked]="switchAquecimentoMode"
                        (change)="switchAquecimento($event)"
                      ></ui-switch>
                    </div>
                  </div>
                </div>
              </div>

              <!--CAMPOS REORGANIZADOS SILVANO-->
              <ng-template
                [ngIf]="
                  tipoSelecionado &&
                  tipoSelecionado.id != 4 &&
                  !switchHideVariables
                "
              >
                <div class="form-row">
                  <div
                    class="col-md-3 col-12"
                    *ngIf="
                      (tipoSelecionado && tipoSelecionado.id == 1) ||
                      switchAquecimentoMode
                    "
                  >
                    <div class="form-group mb-2">
                      <label for="series"
                        >Séries
                        <span
                          *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                          style="color: red"
                          >*</span
                        ></label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          id="series"
                          mask="0*"
                          class="form-control"
                          name="series"
                          [(ngModel)]="exercicie.series"
                          #series="ngModel"
                          gt="0"
                          required
                        />
                      </div>
                      <small
                        class="form-text text-muted danger"
                        *ngIf="
                          (series.errors?.required || series.errors?.gt) &&
                          tipoSelecionado &&
                          tipoSelecionado.id == 1
                        "
                        >Você deve informar a quantidade de séries</small
                      >
                    </div>
                  </div>

                  <div
                    [ngClass]="
                      (tipoSelecionado && tipoSelecionado.id == 1) ||
                      switchAquecimentoMode
                        ? 'col-md-2 col-12'
                        : 'col-md-3 col-12'
                    "
                  >
                    <div class="form-group mb-2">
                      <label for="rep">Tipo</label>
                      <div class="input-group">
                        <div
                          class="d-flex d-md-none justify-content-center align-items-center"
                          role="group"
                        >
                          <img
                            src="./assets/img/repeticoes.svg"
                            alt="Logo"
                            class="mr-1 duration-switch-imgs"
                          /><ui-switch
                            class="switchery switchery-warning"
                            size="small"
                            id="bla"
                            [checked]="switchRepetitionAndDuration"
                            (change)="switchRepAndDur($event)"
                          ></ui-switch
                          ><img
                            src="./assets/img/stopwatch.svg"
                            alt="Logo"
                            class="ml-1 duration-switch-imgs"
                          />
                        </div>
                        <div
                          class="d-none d-md-flex justify-content-center align-items-center"
                          role="group"
                        >
                          <img
                            src="./assets/img/repeticoes.svg"
                            alt="Logo"
                            class="mr-1 duration-switch-imgs"
                          /><ui-switch
                            class="switchery switchery-warning"
                            id="bla"
                            [checked]="switchRepetitionAndDuration"
                            (change)="switchRepAndDur($event)"
                          ></ui-switch
                          ><img
                            src="./assets/img/stopwatch.svg"
                            alt="Logo"
                            class="ml-1 duration-switch-imgs"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    [ngClass]="
                      (tipoSelecionado && tipoSelecionado.id == 1) ||
                      switchAquecimentoMode
                        ? 'col-md-3 col-12'
                        : 'col-md-4 col-12'
                    "
                  >
                    <div class="form-group mb-2">
                      <label for="rep"
                        >{{
                          switchRepetitionAndDuration
                            ? "Duração"
                            : "Repetições"
                        }}<span style="color: red">*</span></label
                      >
                      <ng-template [ngIf]="!switchRepetitionAndDuration">
                        <div class="input-group">
                          <input
                            type="text"
                            autocomplete="off"
                            id="rep"
                            class="form-control"
                            name="rep"
                            [(ngModel)]="exercicie.repetitions"
                            maxlength="11"
                            #repetitions="ngModel"
                            required
                            aria-describedby="group-repetition"
                          />
                          <div class="input-group-append">
                            <span class="input-group-text" id="group-repetition"
                              >x</span
                            >
                          </div>
                        </div>
                        <small
                          class="form-text text-muted danger"
                          *ngIf="
                            repetitions.errors?.required ||
                            repetitions.errors?.gt
                          "
                          >Você deve informar a quantidade de repetições</small
                        >
                      </ng-template>
                      <ng-template [ngIf]="switchRepetitionAndDuration">
                        <ngb-timepicker
                          name="timerDuration"
                          [spinners]="false"
                          [seconds]="true"
                          [(ngModel)]="exercicie.timeDuration"
                          required
                          #duration1="ngModel"
                        ></ngb-timepicker>
                        <small
                          class="form-text text-muted danger"
                          *ngIf="duration1.errors?.required"
                          >Você deve informar a duração</small
                        >
                      </ng-template>
                    </div>
                  </div>
                  <div
                    [ngClass]="
                      (tipoSelecionado && tipoSelecionado.id == 1) ||
                      switchAquecimentoMode
                        ? 'col-md-4 col-12'
                        : 'col-md-5 col-12'
                    "
                  >
                    <div class="form-group mb-2">
                      <div class="d-md-none" role="group">
                        <label for="carga">Carga Total</label>
                      </div>
                      <div class="d-none d-md-block">
                        <label for="carga">Carga sugerida total</label>
                      </div>
                      <div class="input-group">
                        <div
                          class="input-group-prepend"
                          placement="top"
                          ngbTooltip="Clique para informar peso corporal."
                        >
                          <div class="input-group-text" id="checkbox-addon1">
                            <div class="checkbox checkbox-sm">
                              <input
                                type="checkbox"
                                id="checkboxInputGroup"
                                [(ngModel)]="exercicie.corporalLoad"
                                (change)="zeraCarga()"
                                name="checkbox"
                              />
                              <label for="checkboxInputGroup"></label>
                            </div>
                          </div>
                        </div>
                        <input
                          type="text"
                          autocomplete="off"
                          id="carga"
                          class="form-control"
                          [disabled]="exercicie.corporalLoad"
                          name="carga"
                          [(ngModel)]="exercicie.load"
                          #carga="ngModel"
                          gt="0"
                          aria-describedby="checkbox-addon1"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text" id="group-carga"
                            >KG</span
                          >
                        </div>
                      </div>
                      <small
                        class="form-text text-muted danger"
                        *ngIf="carga.errors?.required || carga.errors?.gt"
                        >Você deve informar a carga total</small
                      >
                    </div>
                  </div>
                  <div class="col-md-2 col-12" *ngIf="exercicie.loadFeedback">
                    <div class="form-group mb-2">
                      <label for="loadFeedback">Feedback Carga Total</label>
                      <div class="input-group">
                        <input
                          type="text"
                          autocomplete="off"
                          id="loadFeedback"
                          class="form-control"
                          name="loadFeedback"
                          [disabled]="true"
                          [value]="
                            exercicie.loadFeedback != null
                              ? exercicie.loadFeedback
                              : 'N/A'
                          "
                          aria-describedby="group-loadFeedback"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text" id="group-loadFeedback"
                            >KG</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>

              <!-- <ng-template [ngIf]="(tipoSelecionado && tipoSelecionado.id==1 || switchAquecimentoMode) && !switchHideVariables">
                <div class="form-row">
                  <div class="col-md-3 col-12" [ngClass]="(tipoSelecionado && tipoSelecionado.id!=1 && switchAquecimentoMode) ? 'col-md-3 col-12' : 'col-md-3 col-12'">
                    <div class="form-group mb-2">
                      <label for="series">Séries <span *ngIf="tipoSelecionado && tipoSelecionado.id==1" style="color: red">*</span></label>
                      <div class="input-group">
                        <input type="text" id="series" mask="0*" class="form-control" name="series" [(ngModel)]="exercicie.series" #series="ngModel" gt="0" required>
                      </div>
                      <small class="form-text text-muted danger" *ngIf="(series.errors?.required || series.errors?.gt) && tipoSelecionado && tipoSelecionado.id==1">Você deve informar a quantidade de séries</small>
                    </div>
                  </div>
                  </div>
                <div class="form-row" *ngIf="tipoSelecionado && tipoSelecionado.id==1">
                  <div class="col-md-2 col-12">
                    <div class="form-group mb-2">
                      <label for="rep">Tipo</label>
                      <div class="input-group" >
                        <div class="d-md-none" role="group">
                          <ui-switch class="switchery switchery-warning" size="small" id="bla" [checked]="switchRepetitionAndDuration" (change)="switchRepAndDur($event)"></ui-switch>
                        </div>
                        <div class="d-none d-md-block">
                          <ui-switch class="switchery switchery-warning"  id="bla"  [checked]="switchRepetitionAndDuration" (change)="switchRepAndDur($event)"></ui-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-12">
                    <div class="form-group mb-2">
                      <label for="rep">{{switchRepetitionAndDuration ? 'Duração' : 'Repetições'}}<span style="color: red">*</span></label>
                      <ng-template [ngIf]="!switchRepetitionAndDuration">
                        <div class="input-group" >
                          <input type="text" autocomplete="off" id="rep" class="form-control" name="rep" [(ngModel)]="exercicie.repetitions" maxlength="11" #repetitions="ngModel" required aria-describedby="group-repetition" >
                          <div class="input-group-append">
                            <span class="input-group-text" id="group-repetition">x</span>
                          </div>
                        </div>
                        <small class="form-text text-muted danger" *ngIf="repetitions.errors?.required || repetitions.errors?.gt">Você deve informar a quantidade de repetições</small>
                      </ng-template>
                      <ng-template [ngIf]="switchRepetitionAndDuration">
                        <ngb-timepicker name="timerDuration" [spinners]="false" [seconds]="true" [(ngModel)]="exercicie.timeDuration" required #duration1="ngModel"></ngb-timepicker>
                        <small class="form-text text-muted danger" *ngIf="duration1.errors?.required">Você deve informar a duração</small>
                      </ng-template>
                    </div>
                  </div>
                  <div [ngClass]="exercicie.loadFeedback ? 'col-md-3 col-12' : 'col-md-5 col-12'">
                    <div class="form-group mb-2">
                      <div class="d-md-none" role="group">
                        <label for="carga">Carga Total</label>
                      </div>
                      <div class="d-none d-md-block">
                        <label for="carga">Carga sugerida total</label>
                      </div>
                      <div class="input-group">
                        <div class="input-group-prepend" placement="top" ngbTooltip="Clique para informar peso corporal.">
                          <div class="input-group-text" id="checkbox-addon1">
                            <div class="checkbox checkbox-sm">
                              <input type="checkbox" id="checkboxInputGroup" [(ngModel)]="exercicie.corporalLoad" (change)="zeraCarga()" name="checkbox">
                              <label for="checkboxInputGroup"></label>
                            </div>
                          </div>
                        </div>
                        <input type="text" autocomplete="off" id="carga"  class="form-control" [disabled]="exercicie.corporalLoad" name="carga" [(ngModel)]="exercicie.load" #carga="ngModel" gt="0" aria-describedby="checkbox-addon1">
                        <div class="input-group-append">
                          <span class="input-group-text" id="group-carga">KG</span>
                        </div>
                      </div>
                      <small class="form-text text-muted danger" *ngIf="carga.errors?.required || carga.errors?.gt">Você deve informar a carga total</small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12" *ngIf="exercicie.loadFeedback">
                    <div class="form-group mb-2">
                      <label for="loadFeedback">Feedback Carga Total</label>
                      <div class="input-group">
                        <input type="text" autocomplete="off" id="loadFeedback"  class="form-control" name="loadFeedback" [disabled]="true" [value]="exercicie.loadFeedback!=null ? exercicie.loadFeedback : 'N/A'"   aria-describedby="group-loadFeedback" >
                        <div class="input-group-append" >
                          <span class="input-group-text" id="group-loadFeedback">KG</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template> -->

              <!-- <ng-template [ngIf]="tipoSelecionado && (tipoSelecionado.id==2 || tipoSelecionado.id==3) && !switchHideVariables">
                <div class="form-row">
                  <div class="col-md-2 col-12">
                    <div class="form-group mb-2">
                      <label for="rep">Tipo</label>
                      <div class="input-group" >
                        <div class="d-md-none" role="group">
                          <ui-switch class="switchery switchery-warning" size="small" id="bla" [checked]="switchRepetitionAndDuration" (change)="switchRepAndDur($event)"></ui-switch>
                        </div>
                        <div class="d-none d-md-block">
                          <ui-switch class="switchery switchery-warning"  id="bla"  [checked]="switchRepetitionAndDuration" (change)="switchRepAndDur($event)"></ui-switch>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-12">
                    <div class="form-group mb-2">
                      <label for="rep">{{switchRepetitionAndDuration ? 'Duração' : 'Repetições'}}<span style="color: red">*</span></label>
                      <ng-template [ngIf]="!switchRepetitionAndDuration">
                        <div class="input-group" >
                          <input type="text" autocomplete="off" id="rep" class="form-control" name="rep" [(ngModel)]="exercicie.repetitions" #repetitions="ngModel" required aria-describedby="group-repetition" maxlength="11" >
                          <div class="input-group-append">
                            <span class="input-group-text" id="group-repetition">x</span>
                          </div>
                        </div>
                        <small class="form-text text-muted danger" *ngIf="repetitions.errors?.required || repetitions.errors?.gt">Você deve informar a quantidade de repetições</small>
                      </ng-template>
                      <ng-template [ngIf]="switchRepetitionAndDuration">
                        <ngb-timepicker name="timerDuration" [spinners]="false" [seconds]="true" [(ngModel)]="exercicie.timeDuration" required #duration1="ngModel"></ngb-timepicker>
                        <small class="form-text text-muted danger" *ngIf="duration1.errors?.required">Você deve informar a duração 2</small>
                      </ng-template>
                    </div>
                  </div>


                  <div [ngClass]="exercicie.loadFeedback ? 'col-md-3 col-12' : 'col-md-5 col-12'">
                    <div class="form-group mb-2">
                      <div class="d-md-none" role="group">
                        <label for="carga">Carga Total</label>
                      </div>
                      <div class="d-none d-md-block">
                        <label for="carga">Carga sugerida total</label>
                      </div>
                      <div class="input-group">
                        <div class="input-group-prepend" placement="top" ngbTooltip="Clique para informar peso corporal.">
                          <div class="input-group-text" id="checkbox-addon1">
                            <div class="checkbox checkbox-sm">
                              <input type="checkbox" id="checkboxInputGroup" [(ngModel)]="exercicie.corporalLoad"  (change)="zeraCarga()" name="checkbox">
                              <label for="checkboxInputGroup"></label>
                            </div>
                          </div>
                        </div>
                        <input type="text" autocomplete="off" id="carga"  class="form-control" [disabled]="exercicie.corporalLoad" name="carga" [(ngModel)]="exercicie.load" #carga="ngModel" gt="0" aria-describedby="checkbox-addon1">
                        <div class="input-group-append">
                          <span class="input-group-text" id="group-carga">KG</span>
                        </div>
                      </div>
                      <small class="form-text text-muted danger" *ngIf="carga.errors?.required || carga.errors?.gt">Você deve informar a carga total</small>
                    </div>
                  </div>
                  <div class="col-md-2 col-12" *ngIf="exercicie.loadFeedback">
                    <div class="form-group mb-2">
                      <label for="loadFeedback">Feedback Carga Total</label>
                      <div class="input-group">
                        <input type="text" autocomplete="off" id="loadFeedback"  class="form-control" name="loadFeedback" [disabled]="true" [value]="exercicie.loadFeedback!=null ? exercicie.loadFeedback : 'N/A'"   aria-describedby="group-loadFeedback" >
                        <div class="input-group-append" >
                          <span class="input-group-text" id="group-loadFeedback">KG</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template> -->
              <ng-template
                [ngIf]="
                  tipoSelecionado &&
                  tipoSelecionado.id !== 4 &&
                  !switchHideVariables
                "
              >
                <div class="form-row">
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label for="carga">Velocidade</label>
                      <ng-select
                        [items]="velocidade"
                        [notFoundText]="'Nenhuma velocidade encontrada'"
                        name="velocidade"
                        placeholder="Selecionar Velocidade"
                        id="exercselect"
                        [(ngModel)]="exercicie.speed"
                      ></ng-select>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="form-group mb-2">
                      <label for="interval"
                        >Descanso<span
                          *ngIf="
                            tipoSelecionado.id != 2 &&
                            exercicie.conjugado == null
                          "
                          style="color: red"
                          >*</span
                        ></label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          autocomplete="off"
                          id="interval"
                          mask="9*"
                          class="form-control"
                          name="interval"
                          [(ngModel)]="exercicie.breakTime"
                          #interval="ngModel"
                          gt="0"
                          aria-describedby="group-interval"
                          [required]="
                            tipoSelecionado.id == 3 ||
                            (tipoSelecionado.id == 1 &&
                              exercicie.conjugado == null)
                          "
                        />
                        <div class="input-group-append">
                          <span class="input-group-text" id="group-interval"
                            >segundos</span
                          >
                        </div>
                      </div>
                      <small
                        class="form-text text-muted danger"
                        *ngIf="
                          (interval.errors?.required || interval.errors?.gt) &&
                          exercicie.conjugado == null
                        "
                        >Você deve informar o intervalo</small
                      >
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template
                [ngIf]="
                  tipoSelecionado &&
                  tipoSelecionado.id == 4 &&
                  !exercicie.loadFeedback &&
                  !exercicie.repetitionFeedback &&
                  !exercicie.timeFeedback &&
                  !switchHideVariables
                "
              >
                <div class="form-row mb-2 mt-2">
                  <div class="col-md-4 col-12">
                    <div
                      class="custom-switch custom-switch-primary custom-control-inline mb-1 mb-xl-0"
                      placement="top"
                      ngbTooltip="Informe se deseja solicitar o total de repetições."
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="color-switch-1"
                        [(ngModel)]="exercicie.showRepetitionFeedback"
                        name="showRepetitionFeedback"
                      />
                      <label
                        class="custom-control-label mr-1"
                        for="color-switch-1"
                      >
                        <span>Total de Repetições</span>
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-md-4 col-12"
                    placement="top"
                    ngbTooltip="Informe se deseja solicitar o tempo total de execução."
                  >
                    <div
                      class="custom-switch custom-switch-primary custom-control-inline mb-1 mb-xl-0"
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="color-switch-2"
                        [(ngModel)]="exercicie.showTimeFeedback"
                        name="showTimeFeedback"
                      />
                      <label
                        class="custom-control-label mr-1"
                        for="color-switch-2"
                      >
                        <span>Tempo Total de Execução</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-4 col-12">
                    <div
                      class="custom-switch custom-switch-primary custom-control-inline mb-1 mb-xl-0"
                      placement="top"
                      ngbTooltip="Informe se deseja solicitar a carga total utilizada."
                    >
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="color-switch-3"
                        [(ngModel)]="exercicie.showLoadFeedback"
                        name="showLoadFeedback"
                      />
                      <label
                        class="custom-control-label mr-1"
                        for="color-switch-3"
                      >
                        <span>Total de Carga</span>
                      </label>
                    </div>
                  </div>
                </div>
              </ng-template>
              <div class="form-row">
                <div class="col-12">
                  <div class="form-group mb-2">
                    <label for="obse">Observações <span class="badge rounded-pill badge-primary">Não Utilize Emojis ex: 😀🚨</span></label>
                    <textarea
                      id="obse"
                      rows="2"
                      class="form-control"
                      name="obse"
                      maxlength="500"
                      [disabled]="verificaTreinoDeAvaliacaoPreenchido()"
                      [(ngModel)]="exercicie.note"
                      #inputObse="ngModel"
                      placeholder="Você pode escrever observações sobre este exercício"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div
                class="row"
                *ngIf="
                  tipoSelecionado &&
                  tipoSelecionado.id !== 4 &&
                  !switchHideVariables
                "
              >
                <div class="col-md-12 col-12">
                  <div class="form-group mb-2">
                    <label
                      ngbTooltip="Controle apenas visual para ocultar ou exibir a sessão das periodizações do exercício. Caso haja alguma periodização cadastrada no exercício você não conseguirá desativar este controle."
                      >Exibir Periodizações?
                      <i class="fa fa-question-circle"></i
                    ></label>
                    <ui-switch
                      class="switchery switchery-warning ml-2"
                      id="periodizacao"
                      [disabled]="this.progressions.length > 0"
                      [checked]="switchPeriodizacaoMode"
                      (change)="switchPeriodizacao($event)"
                    ></ui-switch>
                  </div>
                </div>
              </div>

              <ng-template [ngIf]="switchPeriodizacaoMode">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <p
                      role="button"
                      tabindex="0"
                      placement="top"
                      ngbTooltip="Aqui você pode configurar periodizações automáticas de qualquer variável deste exercício e a partir de qualquer execução deste treino. Caso não queira alterar alguma variável na periodização basta não preencher a mesma."
                    >
                      Periodizações Automáticas
                      <i class="fa fa-question-circle"></i>
                    </p>
                  </div>
                  <div
                    class="col-md-6 col-12"
                    *ngIf="!isAddingProgression && !isEditingProgression"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-secondary btn-icon float-right"
                      (click)="liberaCadastroProgressao()"
                    >
                      <i class="fa fa-plus-circle"></i
                      ><span class="d-none d-md-inline-block ml-2"
                        >adicionar periodização</span
                      >
                    </button>
                  </div>
                </div>
                <div
                  class="row mb-2"
                  *ngIf="isAddingProgression || isEditingProgression"
                >
                  <div class="col-sm">
                    <div class="form-group mb-2">
                      <label>Tipo de Periodização:</label>
                      <ui-switch
                        class="switchery switchery-warning ml-2"
                        [checked]="switchExecutionAndDate"
                        (change)="switchExeAndDate($event)"
                      >
                      </ui-switch>
                    </div>
                  </div>
                </div>
                <div
                  class="row mb-2"
                  *ngIf="isAddingProgression || isEditingProgression"
                >
                  <div class="col-sm" *ngIf="switchExecutionAndDate">
                    <div class="form-group">
                      <label for="pe"
                        >Execução
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipExecProg"
                        ></i
                      ></label>
                      <input
                        type="text"
                        autocomplete="off"
                        id="pe"
                        class="form-control"
                        mask="9*"
                        name="pe"
                        [(ngModel)]="newProgression.execution"
                        #ipe="ngModel"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-sm" *ngIf="!switchExecutionAndDate">
                    <div class="form-group">
                      <label for="progressionDate"
                        >Data
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipDataProg"
                        ></i
                      ></label>
                      <input
                        type="date"
                        autocomplete="off"
                        id="progressionDate"
                        class="form-control"
                        name="progressionDate"
                        [(ngModel)]="newProgression.progressionDate"
                        #iprogressionDate="ngModel"
                        required
                      />
                    </div>
                  </div>
                  <div
                    class="col-sm"
                    *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                  >
                    <div class="form-group">
                      <label for="ps"
                        >Séries
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipSerProg"
                        ></i
                      ></label>
                      <input
                        type="text"
                        autocomplete="off"
                        id="ps"
                        class="form-control"
                        mask="9*"
                        name="ps"
                        [(ngModel)]="newProgression.series"
                        #ips="ngModel"
                      />
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group">
                      <label for="pr"
                        >{{
                          switchRepetitionAndDuration ? "duração" : "repetições"
                        }}
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipDurProg"
                        ></i
                      ></label>
                      <ng-template [ngIf]="switchRepetitionAndDuration">
                        <ngb-timepicker
                          name="timerDuration"
                          [spinners]="false"
                          [seconds]="true"
                          [(ngModel)]="newProgression.timeDuration"
                          required
                          #duration1="ngModel"
                        ></ngb-timepicker>
                      </ng-template>
                      <ng-template [ngIf]="!switchRepetitionAndDuration">
                        <input
                          type="text"
                          autocomplete="off"
                          id="pra"
                          class="form-control"
                          name="pra"
                          [(ngModel)]="newProgression.repetitions"
                          #ipra="ngModel"
                          maxlength="11"
                        />
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div
                  class="row mb-2"
                  *ngIf="isAddingProgression || isEditingProgression"
                >
                  <div class="col-sm">
                    <div class="form-group">
                      <label for="pc"
                        >Carga
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipCarProg"
                        ></i
                      ></label>
                      <input
                        type="text"
                        autocomplete="off"
                        id="pc"
                        class="form-control"
                        mask="9*"
                        name="pc"
                        [(ngModel)]="newProgression.load"
                        #ipc="ngModel"
                      />
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group">
                      <label for="pv"
                        >Velocidade
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipVelProg"
                        ></i
                      ></label>
                      <ng-select
                        [items]="velocidade"
                        [notFoundText]="'Nenhuma velocidade encontrada'"
                        name="pv"
                        id="pv"
                        [(ngModel)]="newProgression.speed"
                      ></ng-select>
                    </div>
                  </div>
                  <div class="col-sm">
                    <div class="form-group">
                      <label for="pd"
                        >Descanso
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipDesProg"
                        ></i
                      ></label>
                      <input
                        type="text"
                        autocomplete="off"
                        id="pd"
                        class="form-control"
                        mask="9*"
                        name="pd"
                        [(ngModel)]="newProgression.breakTime"
                        #ipd="ngModel"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="row mb-2"
                  *ngIf="isAddingProgression || isEditingProgression"
                >
                  <div class="col-sm">
                    <div class="form-group">
                      <label for="pn"
                        >Observação
                        <i
                          class="fa fa-question-circle"
                          style="cursor: pointer"
                          role="button"
                          tabindex="0"
                          placement="top"
                          [ngbTooltip]="tipNotProg"
                        ></i
                      ></label>
                      <textarea
                        id="pn"
                        rows="3"
                        class="form-control"
                        name="pn"
                        maxlength="500"
                        [(ngModel)]="newProgression.note"
                        #inputObs="ngModel"
                        placeholder="Você pode escrever observações sobre este treino"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <!-- <div class="col-sm" style="align-self: center;">
                    <button type="button" class="btn btn-block gradient-mint btn-icon" style="margin-top: 7px" [disabled]="!verifyNewProgression()" (click)="isEditingProgression ? atualizaProgressao() : cadastraProgressao()"><i class="fa fa-save"></i></button>
                  </div> -->

                <div
                  class="row mb-2"
                  *ngIf="isAddingProgression || isEditingProgression"
                >
                  <div class="col-sm" style="align-self: center">
                    <button
                      type="button"
                      class="btn btn-block btn-outline-danger btn-icon"
                      (click)="cancelaCadastroProgressao()"
                      style="margin-top: 7px"
                    >
                      <i class="fa fa-close"></i>
                    </button>
                  </div>
                  <div class="col-sm" style="align-self: center"></div>
                  <div class="col-sm" style="align-self: center">
                    <button
                      type="button"
                      class="btn btn-block gradient-mint btn-icon"
                      style="margin-top: 7px"
                      [disabled]="!verifyNewProgression()"
                      (click)="
                        isEditingProgression
                          ? atualizaProgressao()
                          : cadastraProgressao()
                      "
                    >
                      <i class="fa fa-save"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="table-responsive">
                      <table class="table table-bordered">
                        <thead class="thead-dark">
                          <tr>
                            <ng-template #tipExecProg
                              >Execução inicial que vai começar esta
                              periodização. Informe obrigatoriamente uma
                              execução maior que 1.</ng-template
                            >
                            <ng-template #tipDataProg
                              >Data inicial que vai começar esta
                              periodização.</ng-template
                            >
                            <ng-template #tipDurProg>{{
                              switchRepetitionAndDuration
                                ? "Novo tempo de duração em segundos"
                                : "Nova quantidade de repetições"
                            }}</ng-template>
                            <ng-template #tipCarProg
                              >Novo valor de carga total.</ng-template
                            >
                            <ng-template #tipVelProg
                              >Novo valor de velocidade.</ng-template
                            >
                            <ng-template #tipDesProg
                              >Novo tempo de descanso.</ng-template
                            >
                            <ng-template #tipNotProg
                              >Novo valor da observação.</ng-template
                            >
                            <ng-template #tipSerProg
                              >Nova quantidade de séries.</ng-template
                            >
                            <ng-template #tipStatProg
                              >Status indicando se a periodização já foi
                              realizada ou não.</ng-template
                            >
                            <th class="text-center p-2">
                              execução inicial
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipExecProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              data inicial
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipDataProg"
                              ></i>
                            </th>
                            <th
                              class="text-center p-2"
                              *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                            >
                              série
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipSerProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              {{
                                switchRepetitionAndDuration
                                  ? "duração"
                                  : "repetições"
                              }}
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipDurProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              carga total
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipCarProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              velocidade
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipVelProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              descanso
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipDesProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              observação
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipNotProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">
                              status
                              <i
                                class="fa fa-question-circle"
                                style="cursor: pointer"
                                role="button"
                                tabindex="0"
                                placement="top"
                                [ngbTooltip]="tipStatProg"
                              ></i>
                            </th>
                            <th class="text-center p-2">#</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let progression of progressions">
                            <td class="text-center p-2">
                              {{
                                progression.execution
                                  ? progression.execution
                                  : "--"
                              }}
                            </td>
                            <td class="text-center p-2">
                              {{
                                progression.progressionDate
                                  ? formatDateBrazil(
                                      progression.progressionDate
                                    )
                                  : "--"
                              }}
                            </td>
                            <td
                              class="text-center p-2"
                              *ngIf="tipoSelecionado && tipoSelecionado.id == 1"
                            >
                              {{
                                progression.series ? progression.series : "--"
                              }}
                            </td>
                            <td class="text-center p-2">
                              {{
                                switchRepetitionAndDuration
                                  ? progression.duration
                                    ? progression.duration
                                    : "--"
                                  : progression.repetitions
                                  ? progression.repetitions
                                  : "--"
                              }}
                            </td>
                            <td class="text-center p-2">
                              {{ progression.load ? progression.load : "--" }}
                            </td>
                            <td class="text-center p-2">
                              {{ progression.speed ? progression.speed : "--" }}
                            </td>
                            <td class="text-center p-2">
                              {{
                                progression.breakTime
                                  ? progression.breakTime
                                  : "--"
                              }}
                            </td>
                            <td class="text-center p-2">
                              {{ progression.note ? progression.note : "--" }}
                            </td>
                            <td class="text-center p-2">
                              {{
                                progression.status ? "Realizada" : "Pendente"
                              }}
                            </td>
                            <td class="text-center p-2">
                              <div
                                class="btn-group btn-group-sm pl-0 pr-0"
                                role="group"
                              >
                                <button
                                  type="button"
                                  [disabled]="progression.status"
                                  (click)="editProgression(progression)"
                                  class="btn btm-sm gradient-mint btn-icon round"
                                >
                                  <i class="fa fa-edit"></i>
                                </button>
                                <button
                                  type="button"
                                  [disabled]="progression.status"
                                  (click)="deleteProgression(progression)"
                                  class="btn btm-sm btn-danger btn-icon round"
                                >
                                  <i class="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                          <tr *ngIf="!progressions || progressions.length == 0">
                            <td colspan="9">
                              <p class="text-center">
                                Nenhuma periodização cadastrada
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template [ngIf]="showFeedback">
                <div class="form-row">
                  <div class="col-md-4 col-12">
                    <div class="form-group mb-2">
                      <label for="loadFeedback">Feedback Carga Total</label>
                      <div class="input-group">
                        <input
                          type="text"
                          autocomplete="off"
                          id="loadFeedback"
                          class="form-control"
                          name="loadFeedback"
                          [disabled]="true"
                          [value]="
                            exercicie.loadFeedback != null
                              ? exercicie.loadFeedback
                              : 'N/A'
                          "
                          aria-describedby="group-loadFeedback"
                        />
                        <div
                          class="input-group-append"
                          *ngIf="exercicie.loadFeedback"
                        >
                          <span class="input-group-text" id="group-loadFeedback"
                            >KG</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12">
                    <div class="form-group mb-2">
                      <label for="repetitionFeedback"
                        >Feedback Repetições</label
                      >
                      <div class="input-group">
                        <input
                          type="text"
                          autocomplete="off"
                          id="repetitionFeedback"
                          class="form-control"
                          name="repetitionFeedback"
                          [disabled]="true"
                          [value]="
                            exercicie.repetitionFeedback != null
                              ? exercicie.repetitionFeedback
                              : 'N/A'
                          "
                          aria-describedby="group-repetitionFeedback"
                        />
                        <div
                          class="input-group-append"
                          *ngIf="exercicie.repetitionFeedback"
                        >
                          <span
                            class="input-group-text"
                            id="group-repetitionFeedback"
                            >X</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-12">
                    <div class="form-group mb-2">
                      <label for="timeFeedback">Feedback Execução</label>
                      <div class="input-group">
                        <input
                          type="text"
                          autocomplete="off"
                          id="timeFeedback"
                          class="form-control"
                          name="timeFeedback"
                          [disabled]="true"
                          [value]="
                            exercicie.timeFeedback != null
                              ? exercicie.timeFeedback
                              : 'N/A'
                          "
                          aria-describedby="group-timeFeedback"
                        />
                        <div
                          class="input-group-append"
                          *ngIf="exercicie.timeFeedback"
                        >
                          <span class="input-group-text" id="group-timeFeedback"
                            >Seg</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template [ngIf]="isEditingExercise">
                <div class="form-row mb-2">
                  <div class="col-md-6 col-12">
                    <button
                      type="button"
                      class="btn btn-lg btn-light float-left"
                      awPreviousStep
                    >
                      Voltar
                    </button>
                  </div>
                  <div class="col-md-6 col-12">
                    <button
                      type="button"
                      *ngIf="verificaExercicio(null)"
                      class="btn btn-lg btn-warning float-right"
                      [disabled]="!verificaPreenchimentoExercicio()"
                      (click)="atualizarExercicio(modal)"
                    >
                      <i class="fa fa-save"></i> Editar Exercício
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-template
                [ngIf]="
                  !isEditingExercise && !verificaTreinoDeAvaliacaoPreenchido()
                "
              >
                <div class="form-row mb-2">
                  <div class="col-md-6 col-12">
                    <button
                      type="button"
                      class="btn btn-lg btn-light float-left"
                      awPreviousStep
                    >
                      Voltar
                    </button>
                  </div>
                  <div class="col-md-6 col-12">
                    <button
                      type="button"
                      class="btn btn-lg btn-warning float-right"
                      [disabled]="!verificaPreenchimentoExercicio()"
                      (click)="adicionarExercicio(modal)"
                    >
                      <i class="fa fa-save"></i> Adicionar Exercício
                    </button>
                  </div>
                </div>
              </ng-template>
            </form>
          </aw-wizard-step>
        </aw-wizard>
      </div>
    </div>
  </div></ng-template
>

<ng-template #modalEditConjugado let-modal>
  <div class="card">
    <div class="card-header">
      <div class="row mb-0">
        <div class="col">
          <h4 class="card-title float-left">
            {{ conjugadosToAdmin.name ? conjugadosToAdmin.name : "Conjugados" }}
          </h4>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-outline-danger btn-icon float-right"
            (click)="modal.close('Close click')"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>
      <div class="row mb-0">
        <div class="col">
          <p>Edite os exercícios deste conjunto</p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="card-body">
        <div class="row" *ngIf="conjugadosToAdmin.list.length > 0">
          <div class="col">
            <ul
              class="list-group mb-2 draglist"
              cdkDropList
              (cdkDropListDropped)="dropConjugado($event)"
            >
              <li
                *ngFor="let exercicio of conjugadosToAdmin.list"
                cdkDrag
                class="list-group-item"
              >
                <div class="media">
                  <span class="dot align-middle mr-2">{{
                    conjugadosToAdmin.list.indexOf(exercicio) + 1
                  }}</span>
                  <div class="media-body">
                    <h5 class="mt-0">{{ exercicio.name }}</h5>
                    <span>{{ getLabelCategory(exercicio.category) }}</span>
                  </div>
                  <div class="d-none d-md-block">
                    <div
                      class="btn-group btn-group-lg float-right"
                      role="group"
                    >
                      <button
                        type="button"
                        class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                        placement="left"
                        role="button"
                        tabindex="0"
                        [ngbTooltip]="
                          tipoSelecionado &&
                          tipoSelecionado.id == 4 &&
                          training &&
                          training.TrainingExecution &&
                          training.TrainingExecution.length > 0
                            ? 'Visualizar exercício'
                            : 'Editar exercício.'
                        "
                        (click)="
                          editarExercicio(exercicio, modalExercicio, modal)
                        "
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                    </div>
                  </div>
                  <div class="d-md-none" role="group">
                    <div class="dropdown btn-group-sm mr-1 mb-1" ngbDropdown>
                      <button
                        type="button"
                        class="btn btn-outline-warning btn-sm dropdown-toggle"
                        ngbDropdownToggle
                      >
                        <i class="ft-more-vertical"></i>
                      </button>
                      <div ngbDropdownMenu class="dropdown-menu" role="menu">
                        <a
                          class="dropdown-item"
                          (click)="
                            editarExercicio(exercicio, modalExercicio, modal)
                          "
                          >{{
                            tipoSelecionado &&
                            tipoSelecionado.id == 4 &&
                            training &&
                            training.TrainingExecution &&
                            training.TrainingExecution.length > 0
                              ? "Visualizar exercício"
                              : "Editar exercício."
                          }}</a
                        >
                        <a
                          class="dropdown-item"
                          (click)="removerExercicio(exercicio)"
                          *ngIf="verificaExercicio(exercicio)"
                          >Remover exercício</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="mb-2 mt-2 ml-3">
                    <i
                      class="fa fa-reorder mr-2 text-muted"
                      cdkDragHandle
                      style="font-size: 25px; cursor: pointer"
                      placement="left"
                      ngbTooltip="Arraste para reordenar este exercício."
                    ></i>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mb-0">
        <div class="col text-center">
          <p
            class="text-danger"
            (click)="modal.close('Close click'); openAssociar(modalConjugados)"
          >
            Para adicionar, remover ou substituir exercícios dentro deste
            conjunto <a><b>clique em gerenciar conjuntos</b></a>
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalConjugados let-modal>
  <div class="card">
    <div class="card-header">
      <div class="row mb-0">
        <div class="col">
          <h4 class="card-title float-left">Gerenciar Conjuntos</h4>
        </div>
        <div class="col">
          <button
            type="button"
            class="btn btn-outline-danger btn-icon float-right"
            (click)="modal.close('Close click')"
          >
            <i class="fa fa-close"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <p class="float-left">
            Associe diferentes exercícios para criar conjuntos biset e triset
          </p>
        </div>
      </div>
    </div>
    <div class="card-content">
      <div class="card-body">
        <div class="row mb-2" *ngIf="addingOrUpdatingConjugado">
          <div class="col">
            <div class="form-group mb-2 scrollable-box-1">
              <label for="trainings"
                >Selecione exercícios para serem incluídos neste conjunto</label
              >
              <ng-select
                [appendTo]="'.scrollable-box-1'"
                [notFoundText]="'Nenhum exercício encontrado'"
                [items]="opcoesParaConjugar"
                bindLabel="name"
                name="trainings"
                placeholder="Selecionar Treinos"
                id="trainings"
                [(ngModel)]="conjugadoAddingOrEditing"
                multiple="true"
              >
                <ng-template ng-label-tmp let-item="item">
                  <span>{{
                    (conjugadoAddingOrEditing.indexOf(item) + 1).toString() +
                      " - " +
                      item.name
                  }}</span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-search="searchTerm"
                >
                  <span>{{
                    conjugadoAddingOrEditing.indexOf(item) > -1
                      ? (
                          conjugadoAddingOrEditing.indexOf(item) + 1
                        ).toString() +
                        " - " +
                        item.name
                      : item.name
                  }}</span>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row mb-2" *ngIf="addingOrUpdatingConjugado">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-danger mb-md-0 float-left"
              (click)="cancelaAddOuEditConjugado()"
            >
              <i class="fa fa-close"></i> Cancelar
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              [disabled]="
                !conjugadoAddingOrEditing || conjugadoAddingOrEditing.length < 2
              "
              class="btn btn-lg btn-warning mb-md-0 float-right"
              (click)="salvarConjugado()"
            >
              <i class="fa fa-save"></i> Salvar Conjunto
            </button>
          </div>
        </div>
        <div class="row mb-2" *ngIf="!addingOrUpdatingConjugado">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-warning mb-md-0 float-right"
              (click)="liberaAddConjugado()"
            >
              <i class="fa fa-plus"></i> Adicionar Conjunto
            </button>
          </div>
        </div>
        <div class="row" *ngIf="conjugados.length > 0">
          <div class="col">
            <ul class="list-group mb-2">
              <li *ngFor="let c of conjugados" class="list-group-item">
                <div class="media">
                  <div class="media-body">
                    <h5 class="mt-0">
                      Conjunto {{ conjugados.indexOf(c) + 1 }}
                    </h5>
                    <span>{{ getLabelAssociados(c.list) }}</span>
                  </div>
                  <div class="btn-group btn-group-lg" role="group">
                    <button
                      type="button"
                      class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                      placement="left"
                      ngbTooltip="Clique para editar este conjunto."
                      (click)="liberaEditConjugado(c)"
                    >
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-lg btn-outline-warning mb-2 mb-md-0"
                      placement="left"
                      ngbTooltip="Clique para remover este conjunto."
                      (click)="deletarConjugado(c)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="row" *ngIf="conjugados.length == 0">
          <div class="col">
            <ul class="list-group mb-2">
              <li class="list-group-item">
                <div class="media">
                  <div class="media-body">
                    <h5 class="mt-0">Nenhum exercício associado.</h5>
                    <span>Adicione um novo conjunto!</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentVideo>
  <ng-template
    [ngIf]="
      urlToPlay.startsWith('https://www.youtube.com/') ||
      urlToPlay.startsWith('http://www.youtube.com/')
    "
  >
    <div class="embed-container">
      <iframe [src]="safeURL" frameborder="0" allowfullscreen></iframe>
    </div>
  </ng-template>
  <ng-template
    [ngIf]="
      !urlToPlay.startsWith('https://www.youtube.com/') &&
      !urlToPlay.startsWith('http://www.youtube.com/')
    "
  >
    <video controls style="width: 100%">
      <source [src]="urlToPlay" type="video/mp4" />
    </video>
  </ng-template>
</ng-template>
<ng-template #contentGif>
  <img style="width: 100%" [src]="urlToPlay" />
</ng-template>

<ng-template #contentTutoriais let-modal>
  <div class="card-header">
    <h4 class="card-title">Tutoriais</h4>
  </div>
  <button class="close-button" (click)="modal.close('Close click')">
    <i class="fa fa-times" aria-hidden="true"></i>
  </button>
  <div class="form-row" style="margin: 5px">
    <ul class="list-group mb-2" style="width: 100%">
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">1</span>
          <div class="media-body">
            <h5 class="mt-0">Como adicionar um novo treino</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=iZ5Ci7O8ols',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
          <div class="d-md-none">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=iZ5Ci7O8ols',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">2</span>
          <div class="media-body">
            <h5 class="mt-0">Como montar circuitos e intervalados</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=AQ1g_qVnVfg',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
          <div class="d-md-none">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=AQ1g_qVnVfg',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">3</span>
          <div class="media-body">
            <h5 class="mt-0">Como criar treino avaliativo</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=FVtWmcRTRok',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
          <div class="d-md-none">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=FVtWmcRTRok',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">4</span>
          <div class="media-body">
            <h5 class="mt-0">Periodização automatizada</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=brg5wo1VHjA',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
          <div class="d-md-none">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=brg5wo1VHjA',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="media">
          <span class="dotModal align-middle mr-2">5</span>
          <div class="media-body">
            <h5 class="mt-0">Biset/triset</h5>
            <span></span>
          </div>
          <div class="d-none d-md-block">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=oc5Ek3sjcxk',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
          <div class="d-md-none">
            <button
              type="button"
              class="btn btn-outline-warning mb-2 mb-md-0"
              (click)="
                viewMidiaTutorial(
                  'https://www.youtube.com/watch?v=oc5Ek3sjcxk',
                  contentVideo
                )
              "
            >
              Vídeo
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</ng-template>

<ngx-spinner></ngx-spinner>
